import { createReducer, on } from '@ngrx/store';
import { BookingPassState } from './booking-pass.state';
import { FilteredBookingPassesDomainEvent } from './booking-pass.events';
import { FilterBookingPassesCommand } from './booking-pass.commands';
import { Id } from '@resident-select/domain/core';

export const bookingPassKey = 'bookingPass';

const initialState: BookingPassState = {
  entities: {},
  byQuery: {},
};

export const bookingPassReducer = createReducer(
  initialState,
  on(FilteredBookingPassesDomainEvent, (state, { data, transactionId }) => {
    if (!data) {
      return state;
    }
    const oldEntities = { ...state.entities };
    const oldFilters = { ...state.byQuery };

    const pasess: Id[] = [];
    for (const element of data) {
      for (const item of element.bookingPasses) {
        oldEntities[item.id] = item;
        pasess.push(item.id);
      }
    }
    oldFilters[transactionId] = pasess;
    return {
      ...state,
      entities: oldEntities,
      byQuery: oldFilters,
    };
  }),

  on(FilterBookingPassesCommand, (state, { transactionId }) => {
    const oldFilters = { ...state.byQuery };
    oldFilters[transactionId] = undefined;
    return {
      ...state,
      byFilter: oldFilters,
    };
  }),
);
